/* src/app/shared/popups/popup-progress-toast/popup-progress-toast.component.scss */
.progress-toast {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  min-width: 320px;
  max-width: 380px;
  box-sizing: border-box;
}
.progress-toast__header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.progress-toast__text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.progress-toast__title {
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--color-text-primary, currentColor);
}
.progress-toast__subtitle {
  font-size: 1.2rem;
  color: var(--color-text-secondary, rgba(0, 0, 0, 0.6));
  line-height: 1.4;
}
.progress-toast__cancel {
  flex: 0 0 auto;
  margin: -6px -6px 0 0;
}
.progress-toast__bar {
  width: 100%;
}
.progress-toast__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
  color: var(--color-text-secondary, rgba(0, 0, 0, 0.6));
  font-variant-numeric: tabular-nums;
}
.progress-toast__percent {
  font-weight: 600;
  color: var(--color-text-primary, currentColor);
}
/*# sourceMappingURL=popup-progress-toast.component.css.map */
